module.exports = __webpack_public_path__ + "static/assets/b9eab8ac378f5a86345ae91584646822.png";